import React, { useState, useEffect } from 'react';
import ChatWindow from './ChatWindow';
import { ChatBubbleOutline } from '@mui/icons-material';
import Badge from '@mui/material/Badge';

import './Chatbox.css';

const Chatbox = ({ userRole = 'admin' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState('');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchUnread = async () => {
      if (!userId) return;
      const res = await fetch(`${API_BASE}/api/messages/unread-count/${userId}`);
      const data = await res.json();
      setUnreadCount(data.unreadCount || 0);
    };
  
    fetchUnread();
  }, [isOpen]);
  return (
    <div className="chatbox-container">
      {!isOpen ? (
        <Badge badgeContent={unreadCount} color="error">
        <button className="chat-toggle-btn" onClick={() => setIsOpen(true)}>
          <ChatBubbleOutline />
        </button>
      </Badge>      
      
      ) : (
        <ChatWindow
          userRole={userRole}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          selectedUserName={selectedUserName}
          setSelectedUserName={setSelectedUserName}
        />
      )}
    </div>
  );
};

export default Chatbox;
